import { useContext } from "react";

import { ClickHouseContext } from "../../contexts/super/ClickHouseContext";

const useClickHouse = () => {
  const context = useContext(ClickHouseContext);
  return context;
};

export default useClickHouse;
